import { trackV2 } from '@gumtree/shared/src/util/track-ga-event';

export const trackFilterOpenChange = (isOpen: boolean, filterKey: string): void => {
    const eventName = isOpen ? 'SRP-refine-modal-section-open' : 'SRP-refine-modal-section-close';

    trackV2(eventName, filterKey);
};
